import { render, staticRenderFns } from "./AssignCourier.vue?vue&type=template&id=6e39b50a&scoped=true&"
import script from "./AssignCourier.vue?vue&type=script&lang=js&"
export * from "./AssignCourier.vue?vue&type=script&lang=js&"
import style0 from "./AssignCourier.vue?vue&type=style&index=0&id=6e39b50a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39b50a",
  null
  
)

export default component.exports